import { render, staticRenderFns } from "./Geometry.vue?vue&type=template&id=a4a56006&"
import script from "./Geometry.vue?vue&type=script&lang=js&"
export * from "./Geometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports